var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Cacheable } from "../../../../lib/cache/cacheable.cls";
import { Process } from "../../../../lib/process/process.cls";
var FifoCache = /** @class */ (function (_super) {
    __extends(FifoCache, _super);
    /**
    * Constructor detail
    * @param iProvider
    * @param config
    * config param must be passed in as object:
    *  {
    *    refreshInterval: 120000,
    *    maxAge: 30000,
    *    restartDelay: 30000
    *  }
    */
    function FifoCache(iProvider) {
        var _this = _super.call(this, iProvider) || this;
        /**
         * @Override
         * key object mappings of the cache
         */
        _this.cacheEntries = {};
        /**
         * @Override
         * revalidate all cachd items
         */
        _this.revalidateCache = function () {
            _this.log(FifoCache.TAG, 'revalidate', _this.cacheEntries);
            var validator = _this.iProvider.itemValidator;
            try {
                for (var key in _this.cacheEntries) {
                    try {
                        validator.validate(_this.cacheEntries[key]);
                    }
                    catch (ex) {
                        _this.log(FifoCache.TAG, 'revalidate EX', ex);
                    }
                }
            }
            catch (exo) {
                _this.log(FifoCache.TAG, 'revalidate EXO', exo);
            }
        };
        _this.log(FifoCache.TAG, 'pid', _this.settings.pid);
        return _this;
    }
    /**
     * @Override
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    FifoCache.prototype.start = function (params) {
        this.log(FifoCache.TAG, 'start', params);
        this.settings = params;
        try {
            // make sure we're stopped
            this.stop();
            this.intervalMonitor =
                setInterval(this.revalidateCache, this.settings.refreshInterval);
        }
        catch (ex) {
            this.log(FifoCache.TAG, 'error starting cache', ex.message);
            var st_1 = setTimeout(function () {
                clearTimeout(st_1);
            }, this.settings.restartDelay);
        }
    };
    /**
     * @Override
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    FifoCache.prototype.stop = function (params) {
        try {
            if (this.intervalMonitor !== null) {
                clearInterval(this.intervalMonitor);
                this.intervalMonitor = null;
            }
            this.log(FifoCache.TAG, "stop done");
        }
        catch (ex) {
            this.log(FifoCache.TAG, 'error stopping cache', ex.message);
        }
    };
    /**
     * @Override
     * return key -> object mapping of the whole cache
     */
    FifoCache.prototype.getItems = function () {
        return this.cacheEntries;
    };
    /**
     * @Override
     * return key -> object mapping of the whole cache
     * @param key
     */
    FifoCache.prototype.getItem = function (key) {
        if (!this.cacheEntries.hasOwnProperty(key)) {
            return null;
        }
        else {
            return this.cacheEntries[key];
        }
    };
    /**
     * @Override
     * add a new entry to the cache with or without associated object
     * and optional expiration time.
     * if the key already exists the itemValidator will patch it
     * @param key
     * @param item new data or not provided so we create a default
     * @param maxAge
     */
    FifoCache.prototype.addItem = function (key, item, maxAge) {
        maxAge = (typeof maxAge !== 'undefined') ? maxAge : this.settings.maxAge;
        item = (typeof item === 'undefined') ? { i: key } : item;
        if (!this.cacheEntries.hasOwnProperty(key)) {
            this.cacheEntries[key] =
                new Cacheable(key, item, this.iProvider.itemValidator.getNowMs(), maxAge);
            this.iProvider.refresh(this.cacheEntries[key]);
        }
        else {
            this.iProvider.itemValidator.
                patchItem(this.cacheEntries[key], item);
        }
    };
    /**
     * @Override
     * add a new entries to the cache with or without associated object
     * and optional expiration time
     * @param mappings
     * @param maxAge
     */
    FifoCache.prototype.addItems = function (mappings, maxAge) {
        maxAge = (typeof maxAge !== 'undefined') ? maxAge : this.settings.maxAge;
        for (var p in mappings) {
            this.addItem(p, mappings[p], maxAge);
        }
    };
    /**
     * @Override
     * remove a single cache entry
     * @param key
     */
    FifoCache.prototype.removeItem = function (key) {
        try {
            delete this.cacheEntries[key];
        }
        catch (ex) {
            return false;
        }
        return true;
    };
    /**
     * @Override
     * remove a list of cache entries
     * @param keys
     */
    FifoCache.prototype.removeItems = function (keys) {
        var _this = this;
        keys.map(function (k) {
            _this.removeItem(k);
        });
        return true;
    };
    /**
     * @Override
     * return all cache keys as array
     * @param mappings
     */
    FifoCache.prototype.asKeysArray = function (mappings) {
        var res = [];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            res.push(p);
        }
        return res;
    };
    /**
     * @Override
     * return all cached objects as array
     * @param mappings
     */
    FifoCache.prototype.asObjectArray = function (mappings) {
        var res = [];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            res.push(mappings[p]);
        }
        return res;
    };
    /**
     * @Override
     * return all cached objects key as symbol name and value as latest price
     * @param mappings
    */
    FifoCache.prototype.getIndexList = function (mappings) {
        var res = {};
        var mainIsin = ['XAUUSD', 'USOUSD', 'NASUSD', 'SPXUSD', 'EURUSD', 'GBPUSD'];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (mainIsin.indexOf(p) != -1) {
                res[p] = this.cacheEntries[p].item;
            }
        }
        return res;
    };
    FifoCache.prototype.asKeysValueArray = function (mappings) {
        var res = {};
        var mainIsin = ['EURUSD', 'GBPUSD', 'USDJPY', 'AUDUSD', 'USDCAD', 'EURGBP', 'GBPJPY'];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (mainIsin.indexOf(p) != -1) {
                res[p] = this.cacheEntries[p].item;
            }
        }
        return res;
    };
    FifoCache.prototype.asKeysValueArrayAll = function (mappings) {
        var res = {};
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (this.cacheEntries[p].item.other.type == 'INDICIES')
                res[this.cacheEntries[p].item.other.isinid] = this.cacheEntries[p].item;
            else
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    };
    FifoCache.prototype.currencyAll = function (mappings) {
        var res = {};
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (this.cacheEntries[p].item.other.type != 'crypto') {
                if (this.cacheEntries[p].item.other.type == 'INDICIES')
                    res[this.cacheEntries[p].item.other.isinid] = this.cacheEntries[p].item;
                else
                    res[p] = this.cacheEntries[p].item;
            }
        }
        return res;
    };
    FifoCache.prototype.getCryptoCurrency = function (mappings) {
        var res = {};
        var mainIsin = ['BTCUSD', 'ETHUSD', 'LTCUSD', 'BCCUSD', 'XRPUSD'];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (mainIsin.indexOf(p) != -1) {
                res[p] = this.cacheEntries[p].item;
            }
        }
        return res;
    };
    FifoCache.prototype.getCommodity = function (mappings) {
        // const res: any = {}
        // const mainIsin: any = ["XAUUSD","XAGUSD","USOUSD","UKOUSD","XNGUSD"]
        // mappings = mappings || this.cacheEntries 
        // for (let p in mappings) {
        //   if(mainIsin.indexOf(p) != -1){
        //     res[p] = this.cacheEntries[p].item
        //   }
        // }
        // return res
        var res = {};
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            //console.log(this.cacheEntries[p].item.other.type)
            if (this.cacheEntries[p].item.other.type == 'Commodities')
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    };
    FifoCache.prototype.getCommodityAll = function (mappings) {
        var res = {};
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            //console.log(this.cacheEntries[p].item.other.type)
            if (this.cacheEntries[p].item.other.type == 'Commodities')
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    };
    FifoCache.prototype.getIndices = function (mappings) {
        var res = {};
        var mainIsin = ["SPXUSD", "D30EUR", "100GBP", "H50HKD", "U30USD"];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (mainIsin.indexOf(p) != -1) {
                res[this.cacheEntries[p].item.other.isinid] = this.cacheEntries[p].item;
            }
        }
        return res;
    };
    FifoCache.prototype.getIndicesAll = function (mappings) {
        var res = {};
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (this.cacheEntries[p].item.other.type == 'INDICIES')
                res[this.cacheEntries[p].item.other.isinid] = this.cacheEntries[p].item;
        }
        return res;
    };
    FifoCache.prototype.getCurrencies = function (mappings) {
        var res = {};
        mappings = mappings || this.cacheEntries;
        console.log('===============>', mappings);
        for (var p in mappings) {
            if (this.cacheEntries[p].item.other.type == 'currencies')
                res[p] = this.cacheEntries[p].item;
        }
        return res;
    };
    FifoCache.prototype.getSegmentType = function (mappings) {
        var res = {};
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            res[p] = this.cacheEntries[p].item.other.type;
        }
        return res;
    };
    FifoCache.prototype.getAllcurrency = function (mappings) {
        var res = [];
        mappings = mappings || this.cacheEntries;
        for (var p in mappings) {
            if (this.cacheEntries[p].item.other.type == 'currencies') {
                if (res.indexOf(this.cacheEntries[p].key.substring(0, 3)) == -1)
                    res.push(this.cacheEntries[p].key.substring(0, 3));
                if (res.indexOf(this.cacheEntries[p].key.substring(3, 6)) == -1)
                    res.push(this.cacheEntries[p].key.substring(3, 6));
            }
        }
        return res;
    };
    /**
     * @Override
     * authenticate using the credentials from params
     * @param params must contain credentials in case process needs auth
     */
    FifoCache.prototype.auth = function (params) { };
    // log tag
    FifoCache.TAG = 'FifoCache';
    return FifoCache;
}(Process));
export { FifoCache };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/cache/fifo-cache.cls.ts
// module id = null
// module chunks = 